// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as City$PorterinFeature from "../../../core/helpers/City.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as UtmHelper$PorterinFeature from "../../../core/helpers/UtmHelper.mjs";
import * as TrucksForm$PorterinFeature from "./TrucksForm.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as SharedHelper$PorterinFeature from "../../../core/helpers/SharedHelper.mjs";
import * as CityConstants$PorterinFeature from "../../../core/constants/CityConstants.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as TwoWheelerForm$PorterinFeature from "./TwoWheelerForm.mjs";
import * as GetFareEstimate$PorterinFeature from "../../../fare-estimate/repo/GetFareEstimate.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as ChangeCategoryCmp$PorterinFeature from "./ChangeCategoryCmp.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../core/helpers/FareEstimateHelper.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../core/helpers/EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as TrucksFormFieldsCmp$PorterinFeature from "./TrucksFormFieldsCmp.mjs";
import * as FareEstimateFormStore$PorterinFeature from "../../../core/constants/FareEstimateFormStore.mjs";
import * as FareEstimateFormsModuleScss from "../styles/FareEstimateForms.module.scss";
import * as CommonLeadFlowAnalytics$PorterinFeature from "../../analytics/CommonLeadFlowAnalytics.mjs";
import * as FareEstimateEventHelper$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/helpers/FareEstimateEventHelper.mjs";
import * as TrucksLeadFlowAnalytics$PorterinFeature from "../../analytics/TrucksLeadFlowAnalytics.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../../../core/constants/FareEstimateResultStoreEn.mjs";

var styles = FareEstimateFormsModuleScss;

function TrucksFormCmp(Props) {
  var onChangeCategory = Props.onChangeCategory;
  var close_modal = Props.close_modal;
  var fare_estimate_vm = Props.fare_estimate_vm;
  var arrow_icon = Props.arrow_icon;
  var category_name = Props.category_name;
  var change_label = Props.change_label;
  var match = Router.useRouter();
  var locale = match.locale;
  var asPath = match.asPath;
  var recaptcha_execute = NextRecaptchaV3.useReCaptcha();
  var recaptcha_context = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var city_context = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var match$1 = React.useState(function () {
        return TrucksForm$PorterinFeature.default_input;
      });
  var setPreviousInput = match$1[1];
  var match$2 = React.useState(function () {
        
      });
  var setResponse = match$2[1];
  var form = TwoWheelerForm$PorterinFeature.Form.useForm(match$1[0], {
        error_msgs: fare_estimate_vm.errors_msgs,
        country: CountryHelpers$PorterinUtils.countryCodeFromLocale(locale)
      }, (function (output, callbacks) {
          var form_data = FareEstimateHelper$PorterinFeature.toApiInput({
                TAG: /* TrucksForm */1,
                _0: {
                  pickup_address: output.pickup_address,
                  drop_address: output.drop_address,
                  name: output.name,
                  mobile: output.mobile,
                  requirement: output.requirement,
                  service_category: FareEstimateResultStoreEn$PorterinFeature.service_category_trucks,
                  consent_for_callback: output.consent_for_callback
                }
              }, undefined, undefined);
          PublishEventsHelper$PorterinFeature.publishEvents(city_context.category, GAEventsConstants$PorterinFeature.gaFareEstimateFormValidation, "" + GAEventsConstants$PorterinFeature.gaEventTrucks + "_" + form_data.mobile + "");
          var match = UtmHelper$PorterinFeature.getUtmStringFromPath(asPath);
          var utm_campaign = match[1];
          var utm_source = match[0];
          PublishEventsHelper$PorterinFeature.publishEventsV2(CommonLeadFlowAnalytics$PorterinFeature.clickEventName(locale), {
                event_category: GAEventsConstants$PorterinFeature.gaTitleHome,
                event_label: EventsTrackerHelper$PorterinFeature.getNumberedEventLabel({
                      hd: output.name,
                      tl: {
                        hd: output.mobile,
                        tl: {
                          hd: "frequency-" + SharedHelper$PorterinFeature.requirementToString(output.requirement) + "",
                          tl: {
                            hd: utm_source,
                            tl: {
                              hd: utm_campaign,
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }),
                language_selected: LocaleHelpers$PorterinUtils.localeToString(locale)
              });
          Js_promise.$$catch((function (error) {
                  Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "HomeTrucksForm - " + error.toString());
                  return Promise.resolve(undefined);
                }), Js_promise.then_((function (validator_response) {
                      if (validator_response.TAG === /* Ok */0) {
                        var match = validator_response._0;
                        var callback_request_data = match.callback_request_data;
                        var redirect_url = match.redirect_url;
                        var geo_region = FareEstimateHelper$PorterinFeature.getParamValue(redirect_url, "geo_region_id", City$PorterinFeature.cityToGeoRegionId(CityConstants$PorterinFeature.dhaka).toString());
                        if (callback_request_data.lead_entry_created) {
                          FareEstimateHelper$PorterinFeature.fireGTEEventsOnLeadCreated(redirect_url, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks, city_context.category, FareEstimateFormStore$PorterinFeature.trucks_wheeler_source, callback_request_data.send_unregistered_event);
                        }
                        var redirect_url_with_cb_data = redirect_url + FareEstimateHelper$PorterinFeature.makeCallbackDataQueryParams(callback_request_data);
                        var validator_response$1 = FareEstimateHelper$PorterinFeature.updateRedirectUrl(validator_response, redirect_url_with_cb_data);
                        var updated_form_data_pickup_address = form_data.pickup_address;
                        var updated_form_data_drop_address = form_data.drop_address;
                        var updated_form_data_name = form_data.name;
                        var updated_form_data_mobile = form_data.mobile;
                        var updated_form_data_requirement = form_data.requirement;
                        var updated_form_data_service_category = form_data.service_category;
                        var updated_form_data_consent_for_callback = form_data.consent_for_callback;
                        var updated_form_data = {
                          geo_region: geo_region,
                          pickup_address: updated_form_data_pickup_address,
                          drop_address: updated_form_data_drop_address,
                          name: updated_form_data_name,
                          mobile: updated_form_data_mobile,
                          requirement: updated_form_data_requirement,
                          service_category: updated_form_data_service_category,
                          consent_for_callback: updated_form_data_consent_for_callback
                        };
                        Js_promise.$$catch((function (error) {
                                PublishEventsHelper$PorterinFeature.publishEvents(Belt_Option.getWithDefault(city_context.city_selected, ""), GAEventsConstants$PorterinFeature.gaFareEstimateError + CountryHelpers$PorterinUtils.countryCodeFromLocaleForGa(locale), city_context.city_selected);
                                Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "HomeTrucksForm Hash - " + error.toString());
                                return Promise.resolve(undefined);
                              }), Js_promise.then_((function (estimate_secure_response) {
                                    if (estimate_secure_response.TAG === /* Ok */0) {
                                      var final_redirect_url = estimate_secure_response._0;
                                      Curry._1(setResponse, (function (param) {
                                              return FareEstimateHelper$PorterinFeature.updateRedirectUrl(validator_response$1, final_redirect_url);
                                            }));
                                      Curry._1(callbacks.notifyOnSuccess, undefined);
                                      Curry._1(close_modal, undefined);
                                      TrucksLeadFlowAnalytics$PorterinFeature.successEvent(city_context.category, form_data.name, form_data.mobile, form_data.requirement, utm_source, utm_campaign, form_data.service_category, city_context.city_selected, locale);
                                      if (locale === LocaleConstants$PorterinUtils.en_AE) {
                                        PublishEventsHelper$PorterinFeature.publishEventsV2(GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulV2Uae, {
                                              name: output.name,
                                              mobile_number: output.mobile,
                                              city: Belt_Option.getWithDefault(city_context.city_selected, ""),
                                              frequency: "" + SharedHelper$PorterinFeature.requirementToString(output.requirement) + "",
                                              language_selected: LocaleHelpers$PorterinUtils.localeToString(locale)
                                            });
                                      }
                                      JsBindings$PorterinUtils.redirect(FareEstimateHelper$PorterinFeature.fareEstimateResultRedirectUrlOms(final_redirect_url, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks, FareEstimateFormStore$PorterinFeature.trucks_wheeler_source, isDesktop, form_data.consent_for_callback));
                                    } else {
                                      Curry._1(setResponse, (function (param) {
                                              return estimate_secure_response;
                                            }));
                                      Curry._1(callbacks.notifyOnFailure, estimate_secure_response._0);
                                    }
                                    return Promise.resolve(undefined);
                                  }), GetFareEstimate$PorterinFeature.getFareEstimateHash(redirect_url_with_cb_data, updated_form_data, recaptcha_execute, recaptcha_context, CountryHelpers$PorterinUtils.countryCodeFromLocaleForOms(locale))));
                      } else {
                        var error = validator_response._0;
                        FareEstimateEventHelper$PorterinFeature.publishFareEstimateFormErrorParameter(error);
                        Curry._1(setResponse, (function (param) {
                                return validator_response;
                              }));
                        Curry._1(callbacks.notifyOnFailure, error);
                      }
                      return Promise.resolve(undefined);
                    }), GetFareEstimate$PorterinFeature.getFareEstimate(form_data, FareEstimateResultStoreEn$PorterinFeature.service_category_trucks, isDesktop, FareEstimateFormStore$PorterinFeature.trucks_wheeler_source, recaptcha_execute, recaptcha_context, CountryHelpers$PorterinUtils.countryCodeFromLocaleForOms(locale))));
        }));
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setPreviousInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  return React.createElement("div", {
              className: styles["component-wrapper"]
            }, React.createElement(ChangeCategoryCmp$PorterinFeature.make, {
                  onChangeCategory: onChangeCategory,
                  className: styles["change-category"],
                  currentCategory: "Trucks",
                  category_name: category_name,
                  change_label: change_label
                }), React.createElement(TrucksFormFieldsCmp$PorterinFeature.make, {
                  form: form,
                  onChangeCategory: onChangeCategory,
                  response: match$2[0],
                  city_context: city_context,
                  fare_estimate_vm: fare_estimate_vm,
                  arrow_icon: arrow_icon
                }));
}

var make = TrucksFormCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
